import {NgModule} from '@angular/core';
import * as login from './index';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {LoginFormComponent} from './components/form/login/login-form.component';
import {IonicModule} from 'ionic-angular';
import {PrismLogoModule} from '../../shared/components/prism-logo/prism-logo.module';

/**
 * Module for the login form
 */
@NgModule({
  declarations: [
    login.LoginFormComponent,
  ],
  exports: [
    LoginFormComponent,
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    PrismLogoModule,
  ],
})
export class UserLoginModule {
}



// WEBPACK FOOTER //
// ./src/app/user/login/login.module.ts